const getELoc = (e) => {
    let x = e.clientX;
    let y = e.clientY;
    let rect = e.target.getBoundingClientRect();

    return {x, y};
};
exports.getELoc = getELoc;
